import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Blogs from "../blogs/Blogs";
import Store from "../store/Store";
import Recipes from "../recipes/Recipes";
import Watermachines from "../watermachines/Watermachines";

import Accessories from "../accessories/Accessories";
import ManageMembers from "./../ManageMembers/ManageMembers";
import AddBlogs from "../blogs/AddBlogs";
import EditBlogs from "../blogs/EditBlogs";

import HomePage from "../Home/HomePage";
import Orders from "../Orders/Orders";
import ManageProducts from "../products/Products";
import PromoCodee from "../promoCode/promoCode";
import Faqs from "../faqs/Faqs";
import AddFaq from "../faqs/AddFaq/AddFaq";
import EditFaq from "../faqs/EditFaq/EditFaq";

function Dashroutes() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="orders" />} />

      <Route path="managemembers" element={<ManageMembers />} />
      <Route path="promo-code" element={<PromoCodee />} />
      <Route path="addfaq" element={<AddFaq />} />
      <Route path="/editfaq/:id" element={<EditFaq />} />

      <Route path="blogs" element={<Blogs />} />
      <Route path="store" element={<Store />} />
      <Route path="recipes" element={<Recipes />} />
      <Route path="dashboardhome" element={<HomePage />} />
      <Route path="watermachines" element={<Watermachines />} />
      <Route path="manageproducts" element={<ManageProducts />} />
      <Route path="/edit/:id" element={<EditBlogs />} />
      <Route path="addblog" element={<AddBlogs />} />
      <Route path="accessories" element={<Accessories />} />
      <Route path="orders" element={<Orders />} />
      <Route path="faqs" element={<Faqs />} />
    </Routes>
  );
}

export default Dashroutes;
